import React from 'react'

const Historypage = () => {
  return (
    <div>Historypage</div>
  )
}

export default Historypage